import { FormControl, RadioGroup, FormLabel, FormControlLabel, Radio } from '@mui/material'
import { FormattedMessage } from 'react-intl'
import { FilterText } from '../types'

function TextFilterType({ onChange }: { onChange: (filterTextType: FilterText) => void }) {
  return (
    <FormControl size="small" margin="normal">
      <FormLabel id="filter-text-type-group">
        <FormattedMessage id="analysis.columnValue.textFilterLabel" />
      </FormLabel>
      <RadioGroup
        defaultValue={FilterText.Equal}
        row
        name="filter-text-type-group"
        onChange={(e) => onChange(e.target.value as FilterText)}
      >
        <FormControlLabel
          value={FilterText.Equal}
          control={<Radio size="small" />}
          label={<FormattedMessage id="analysis.columnValue.keep" />}
        />
        <FormControlLabel
          value={FilterText.Different}
          control={<Radio size="small" />}
          label={<FormattedMessage id="analysis.columnValue.discard" />}
        />
      </RadioGroup>
    </FormControl>
  )
}

export default TextFilterType
